import { IToast } from '../../actions/toast';
import { StoreState } from '../../reducers';

export const selectToasts = (state: StoreState): IToast[] => state.toasts;
